import BaseController from "controllers/marketplace/base"

import React from 'react'
import ReactDOM from 'react-dom';
import MarketPlace from 'components/marketplace/marketPlace';


const marketPlace = document.getElementById('market-place');

class Controller extends BaseController {
  call() {
    ReactDOM.render( <MarketPlace/>, marketPlace);
  }
};

export default Controller;
